import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { iniciDesloginar } from '../../actions/auth'
import { useTranslation } from 'react-i18next';

// SIMPLIFICAT: eliminades les crides a recuperarConfigUsuari, recuperarConfigAplicacio
// i renovarTokenAction — les gestiona MenuPrincipal per evitar crides duplicades.
// UsuariLoginat ara és purament presentacional.

export const UsuariLoginat = () => {
    const dispatch = useDispatch();
    const navegacio = useNavigate();
    const { auth } = useSelector(state => state);
    const [t, i18n] = useTranslation('generic');

    const desloginarUsuari = () => {
        dispatch(iniciDesloginar());
        navegacio('/login', { replace: true });
    }

    if (!auth.tokenJwt) {
        navegacio('/login', { replace: true });
        return null;
    }

    return (
        <div className="mb-0">
            <div className="row">
                <div className="col-6 col-md-7">
                    {auth.admin == 0
                        ? <p className="align-left mt-3"><i className="bi-person-circle me-1"></i>{auth.nom + " " + auth.cognom}</p>
                        : <p className="align-left mt-3">(ADMIN) <i className="bi-person-circle me-1"></i>{auth.nom + " " + auth.cognom}</p>
                    }
                </div>
                <div className="col-6 col-md-5 align-right">
                    <button className="btn btn-primary btn-sm m-1" onClick={desloginarUsuari}>
                        <i className="bi bi-box-arrow-right me-2"></i>Logout
                    </button>
                </div>
            </div>
        </div>
    );
}